import { PayloadAction } from '@reduxjs/toolkit';
import { DTODiffusionModelsTableUD } from '@shared/dto/+model/table/dto_diffusion_models_table_ud';
import { FIELD_OF_TYPE } from '@shared/types/types';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_upsert_table_without_pages = (payload: DTODiffusionModelsTableUD[]): PayloadAction<DTODiffusionModelsTableUD[]> => ({
  type: ENUM__redux_action.ML_ASSET_UPSERT_TABLE_WITHOUT_PAGES,
  payload,
});

export function init_local_ml_asset_upsert_table_without_pages(state: StateMLAsset, action: PayloadAction<DTODiffusionModelsTableUD[]>) {
  if (action.payload.length == 0) return;

  for (let table_update of action.payload) {
    try_update_current_table(state, table_update);

    let table_from_map = state.tables_map.get(table_update.hash_crc32_settings_table);

    if (table_from_map) {
      //update table
      table_from_map = update_table(table_from_map, table_update);
      state.tables_map.set(table_update.hash_crc32_settings_table, table_from_map);
    } else {
      //insert table
      state.tables_map.set(table_update.hash_crc32_settings_table, table_update);
    }
  }

  //need to force re-render
  state.tables_map = new Map(state.tables_map);
}

function try_update_current_table(state: StateMLAsset, table: DTODiffusionModelsTableUD) {
  if (state.current_table.hash_crc32_settings_table != table.hash_crc32_settings_table) return;

  state.current_table = update_table(state.current_table, table);
}

function update_table(to: DTODiffusionModelsTableUD, from: DTODiffusionModelsTableUD) {
  if (to.hash_crc32_settings_table != from.hash_crc32_settings_table) return to;

  let out = to.clone();

  let ignored_columns: FIELD_OF_TYPE<DTODiffusionModelsTableUD>[] = ['pages_map'];

  for (let key of Object.keys(from) as (keyof DTODiffusionModelsTableUD)[]) {
    if (ignored_columns.includes(key as FIELD_OF_TYPE<DTODiffusionModelsTableUD>)) continue;

    (out as any)[key] = from[key];
  }

  return out;
}
